/* eslint-disable no-unused-vars */

import { useEffect, useRef, useState } from "react"
import { DateTime } from "luxon"
import useSWR, { useSWRConfig } from 'swr'

import { OrdersByCustomers } from './components/OrdersByCustomers'
import { FiClock, FiSearch, FiUsers } from 'react-icons/fi'

import { NavBar } from "../../components/NavBar"
import { Toast } from "../../utils/Toast"
import { api } from "../../api/api"
import _ from "lodash"
import '../admin.css'


export function CustomerPage() {
  const refSearch = useRef()
  const [search, setSearch] = useState('')

  const [customerSelect, setCustomerSelect] = useState(null)

  const { mutate } = useSWRConfig()
  const { data, isLoading } = useSWR(['/customers', search], async (args) => {
    const response = await api.get(`/customers?qs=${args[1]}`)
    return _.orderBy(response?.data ?? [], 'name', 'asc')
  })

  useEffect(() => {
    if (customerSelect !== null)
      new window.bootstrap.Modal(document.getElementById('modalOrdersByCustomer'), {}).toggle()
  }, [customerSelect])

  async function destroy(id) {
    const confirmation = await Toast.confirm()
    if (confirmation) {
      await api.delete('/customers/' + id)
      await mutate('/customers')
    }
  }

  async function reportInactiveClients() {
    const value = await Toast.getValue('Digite a quantidade de dias', null, null, null, 'number')

    if (value === undefined) {
      return
    }

    if (value === '') {
      return Toast.warning('Deve ser digitado um valor em dias')
    }

    const date = DateTime.local().minus({ day: value }).toSQLDate()
    const response = await api.get(`/customers/list-inactive?date=${date}`)

    if (response.data.length === 0) {
      return Toast.warning('Não tem nenhum cliente nessa data')
    }

    const responseData = _.orderBy(response.data.map(e => {
      return {
        'Nome': e.name,
        'Telefone': e.phone,
        'Ultimo pedido': DateTime.fromISO(e.lastOrder).toFormat('dd/MM/yyyy'),
      }
    }), 'Ultimo pedido', 'asc')

    const tableHtml = `
      <html>
        <head>
          <title>Recuperação de clientes</title>
          <style>
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              margin: 0;
              font-family: Arial, sans-serif;
            }
            table {
              width: 800px;
              border-collapse: collapse;
              border-radius: 4px;
              overflow: hidden;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            }
            table, th, td {
              border: 1px solid #ddd;
            }
            th, td {
              padding: 12px;
              text-align: left;
            }
            th {
              background-color: #4CAF50;
              color: white;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <table>
            <thead>
              <tr>${Object.keys(responseData[0]).map(key => `<th>${key}</th>`).join('')}</tr>
            </thead>
            <tbody>
              ${responseData.map(row => `
                <tr>${Object.values(row).map(value => `<td>${value}</td>`).join('')}</tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    var newWindow = window.open('', '', `width=${window.screen.width},height=${window.screen.height}`);
    newWindow.document.write(tableHtml)
  }

  return (
    <>
      {customerSelect && <OrdersByCustomers id={customerSelect} clear={() => setCustomerSelect(null)} />}
      <NavBar>
        <main className="admin-page customer-page">
          <header className="admin-page-header"><div><h1>Clientes</h1><p>Consulte o histórico e identifique oportunidades de recuperação</p></div><button className="admin-secondary-button" onClick={reportInactiveClients}><FiClock /> Recuperar clientes</button></header>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Clientes cadastrados</h2><p>{data?.length || 0} clientes encontrados</p></div><FiUsers size={19} /></div>
            <div className="admin-filter-bar"><label><span>Pesquisar cliente</span><input type="search" ref={refSearch} placeholder="Nome ou telefone" onKeyDown={(event) => event.key === 'Enter' && setSearch(refSearch.current?.value)} /></label><button className="admin-primary-button" onClick={() => setSearch(refSearch.current?.value)}><FiSearch /> Pesquisar</button></div>

          {isLoading && (
            <div className="admin-loading"><div className="spinner-border" role="status"><span className="visually-hidden">Carregando...</span></div></div>
          )}

          {data && (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th >Nome</th>
                    <th >Telefone</th>
                    <th >Ultimo pedido</th>
                    <th >Quantidade de pedido</th>
                    <th >Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((customer) => {
                    return (
                      <tr key={customer.id}>
                        <td data-label="Nome"><strong>{customer.name}</strong></td>
                        <td data-label="Telefone">{customer.phone?.replaceAll('_', '')}</td>
                        <td data-label="Último pedido">{customer.lastOrder ? DateTime.fromISO(customer.lastOrder).plus({ hours: -3 }).toFormat("dd/MM/yyyy HH:mm") : 'Sem pedidos'}</td>
                        <td data-label="Pedidos">{customer.countOrder}</td>
                        <td data-label="Ações">
                          <button className="admin-icon-button" onClick={() => setCustomerSelect(customer.id)} aria-label="Ver histórico"><FiSearch /></button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              {data.length === 0 && <div className="admin-empty"><FiUsers size={25} /><strong>Nenhum cliente encontrado</strong><span>Ajuste a pesquisa e tente novamente.</span></div>}
            </div>
          )}
          </section>
        </main>
      </NavBar>
    </>
  )
}


